<template>
  <div class="jumbotron jumbotron-fluid page-not-found">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-8">
          <img
            :src="require('@/assets/abeja_logo.png')"
            class="img-fluid mx-auto d-block abeja-icon"
            alt="Responsive image"
          >
        </div>
      </div>

      <div class="row justify-content-md-center">
        <div class="col-md-8">
          <h2 class="display-3 text-center">
            404
          </h2>
          <h2 class="display-3 text-center">
            Page Not Found.
          </h2>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-md-8">
          <h3 class="text-center">
            {{ $t("PageNotFound.MainMessage") }}
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button
            type="button"
            class="btn btn-borderless-primary btn-lg"
            @click="changeLang"
          >
            <i class="fas fa-language fa-lg" />
            {{ $t('General.ChangeLang') }}
          </button>
        </div>
      </div>
      <div
        v-if="isLogin"
        class="row"
      >
        <div class="col text-center">
          <button
            type="button"
            class="btn btn-borderless-secondary"
            @click="goHome"
          >
            {{ $t("PageNotFound.GoHomePage") }}
          </button>
        </div>
      </div>
      <div
        v-else
        class="row"
      >
        <div class="col text-center">
          <button
            type="button"
            class="btn btn-borderless-secondary"
            @click="goLogin"
          >
            {{ $t("PageNotFound.GoLogin") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
export default {
  name: 'NotFound',
  computed: {
    ...mapState(['lang']),
    ...mapGetters('auth', ['isLogin'])
  },
  methods: {
    ...mapActions(['setLanguage']),
    goHome() {
      this.$router.push({ name: 'SmartScheduling' })
    },
    changeLang() {
      this.setLanguage(this.lang === 'ja' ? 'en' : 'ja')
    },
    goLogin() {
      this.$router.push({
        name: 'Login',
        lang: this.lang
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.page-not-found {
  height: 100vh;
  margin-bottom: 0;
}
.abeja-app-full-page {
  margin: 0;
}
.abeja-icon {
  max-width: 160px;
}
</style>
